export const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || 'https://moveland-example.onrender.com').replace(/\/$/, '')
